import { Box, Card, CardHeader, CardBody, Heading, Text, VStack } from '@chakra-ui/react'
import { useNavigate, useParams, useLocation } from 'react-router-dom'
import { AdminLayout } from '@/components/layout/AdminLayout'
import { useThemeColors } from '@/hooks/useThemeColors'
import { DownloadSoaForm } from '@/components/forms/DownloadSoaForm'

export default function DownloadSoaPage() {
  const colors = useThemeColors()
  const navigate = useNavigate()
  const location = useLocation()
  const params = useParams<{ shippingLineId: string; soaId: string }>()
  const paramsShippingLineId = params.shippingLineId
  const soaId = params.soaId ? parseInt(params.soaId, 10) : undefined

  // Get data from navigation state or route params
  const navigationState = location.state as
    | {
        selectedBookingIds?: number[]
        shippingLineName?: string
        shippingLineId?: string
        soaId?: number
      }
    | null
  const selectedBookingIds = navigationState?.selectedBookingIds || []
  const shippingLineName = navigationState?.shippingLineName || ''
  const finalShippingLineId =
    navigationState?.shippingLineId || paramsShippingLineId
  const finalSoaId = navigationState?.soaId || soaId

  const handleSuccess = () => {
    navigate(`/shipping-lines/financial-statements/${finalShippingLineId}`)
  }

  const handleCancel = () => {
    navigate(`/shipping-lines/financial-statements/${finalShippingLineId}`)
  }

  return (
    <AdminLayout constrainedContent>
      <Box
        p={4}
        minW={0}
        h="100%"
        overflow="auto"
        display="flex"
        flexDirection="column"
      >
        <VStack spacing={0} align="stretch" flex="1" minH={0} minW={0}>
          <Card minW={0}>
            <CardHeader>
              <Heading size="md" mb={1}>
                Download Statement of Account
              </Heading>
            </CardHeader>
            <CardBody minW={0} overflow="visible">
              <DownloadSoaForm
                shippingLineId={finalShippingLineId || ''}
                shippingLineName={shippingLineName}
                selectedBookingIds={selectedBookingIds}
                soaId={finalSoaId}
                onSuccess={handleSuccess}
                onCancel={handleCancel}
              />
            </CardBody>
          </Card>
        </VStack>
      </Box>
    </AdminLayout>
  )
}

